import { motion } from "framer-motion";

// The red thread — "hilo rojo": connection, life, union, heartbeat.
// Animated draw-on when it scrolls into view.
export function RedThread({ className = "", strokeWidth = 1.4, animate = true }) {
  return (
    <svg
      className={className}
      viewBox="0 0 1000 160"
      fill="none"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <motion.path
        d="M0 96 C 150 96, 210 96, 300 80 C 360 68, 372 20, 340 14 C 312 9, 300 44, 330 60 C 372 82, 470 90, 560 84 C 720 74, 820 118, 1000 74"
        stroke="hsl(var(--latir-red))"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        initial={animate ? { pathLength: 0, opacity: 0 } : false}
        whileInView={animate ? { pathLength: 1, opacity: 1 } : undefined}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 2.4, ease: [0.16, 1, 0.3, 1] }}
      />
    </svg>
  );
}

// A vertical hair-thin thread with a small knot — used as a quiet divider.
export function ThreadDrop({ className = "", height = 120 }) {
  return (
    <svg className={className} width="24" height={height} viewBox="0 0 24 120" fill="none" aria-hidden="true">
      <motion.path
        d="M12 0 C 12 40, 12 44, 12 52 C 12 66, 2 70, 2 60 C 2 52, 12 52, 12 62 C 12 90, 12 96, 12 120"
        stroke="hsl(var(--latir-red))"
        strokeWidth="1.1"
        strokeLinecap="round"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }}
      />
    </svg>
  );
}

// The chair — a recurring emblem of the LATIR identity, drawn as a fine line.
export function ChairLine({ className = "", stroke = "hsl(var(--ink) / 0.5)", animate = true }) {
  const t = {
    duration: 2.2,
    ease: [0.16, 1, 0.3, 1],
  };
  const common = {
    stroke,
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    initial: animate ? { pathLength: 0, opacity: 0 } : false,
    whileInView: animate ? { pathLength: 1, opacity: 1 } : undefined,
    viewport: { once: true, margin: "-8%" },
    transition: t,
  };
  return (
    <svg className={className} viewBox="0 0 120 200" fill="none" aria-hidden="true">
      {/* backrest */}
      <motion.path d="M40 18 L44 108" {...common} />
      <motion.path d="M78 18 L74 108" {...common} />
      <motion.path d="M40 18 C 52 8, 66 8, 78 18" {...common} transition={{ ...t, delay: 0.1 }} />
      <motion.path d="M42 40 L76 40" {...common} transition={{ ...t, delay: 0.2 }} />
      <motion.path d="M41 64 L75 64" {...common} transition={{ ...t, delay: 0.28 }} />
      {/* seat */}
      <motion.path d="M30 108 L88 108" {...common} transition={{ ...t, delay: 0.35 }} />
      <motion.path d="M30 108 L26 118 L92 118 L88 108" {...common} transition={{ ...t, delay: 0.4 }} />
      {/* legs */}
      <motion.path d="M30 118 L24 192" {...common} transition={{ ...t, delay: 0.5 }} />
      <motion.path d="M92 118 L98 192" {...common} transition={{ ...t, delay: 0.5 }} />
      <motion.path d="M46 118 L44 186" {...common} transition={{ ...t, delay: 0.55 }} />
      <motion.path d="M76 118 L78 186" {...common} transition={{ ...t, delay: 0.55 }} />
      {/* stretcher */}
      <motion.path d="M30 156 L90 156" {...common} transition={{ ...t, delay: 0.62 }} />
    </svg>
  );
}
